<template>
  <div>
    <div class="toptitle">
      备课名称<el-input
        placeholder="请输入内容"
        prefix-icon="el-icon-search"
        v-model="lessonTitle"
        size="small"
        @input="handletitle"
      >
      </el-input>
      <el-button
        type="primary"
        size="small"
        style="margin-right: 20px; margin-left: 10px"
        @click="handletitle"
        >搜索</el-button
      >
      <!-- 年级 -->
      <el-dropdown
        size="small"
        split-button
        style="margin-right: 20px"
        type="primary"
        @command="handleGrade"
      >
        {{ gradeOne }}
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            :command="item"
            v-for="(item, index) in gradedata"
            :key="index"
            >{{ item.grade_name }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
      <!-- 科目 -->
      <el-dropdown
        size="small"
        split-button
        type="primary"
        @command="handleSub"
      >
        {{ subjectOne }}
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            :command="item"
            v-for="(item, index) in subjectdata"
            :key="index"
            >{{ item.subject_name }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
      <div class="fr" style="margin-right: 40px">
        <span class="demonstration">创建时间：</span>
        <el-date-picker
          v-model="value2"
          type="datetimerange"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
          @blur="getTime"
          format="yyyy-MM-dd HH:mm"
        >
        </el-date-picker>
      </div>
    </div>
  </div>
</template>

<script>
import URL from "@/api/index";
import axios from "axios";
import { rand } from "../../api/http";
import VueEvent from "@/model/VueEvent";
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      value2: "",
      lessonTitle: "",
      gradeOne: "年级",
      gradedata: [],
      gid: "",
      subjectOne: "科目",
      subjectdata: [],
    };
  },
  components: {},
  watch: {
    value2: function (val) {
      // console.log(val);
      if (val == null) {
        VueEvent.$emit("time", 0);
      }
    },
  },
  mounted() {
    this.getallgrade();
  },
  methods: {
    getTime() {
      VueEvent.$emit("time", this.value2);
    },
    handletitle() {
      // 备课数据上报
      var hhh = JSON.parse(localStorage.getItem("loginInfo"));
      this.getRecordRjw(hhh);
      VueEvent.$emit("title", this.lessonTitle);
    },
    // 搜索数据上报
    getRecordRjw(hh) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入我的备课
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "preparelessons_search",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了我的备课的搜索功能",
          data: {
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id:JSON.parse(localStorage.getItem("prepare_traceid")),
            searchcontent: this.lessonTitle,
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
    //获取年级
    getallgrade() {
      this.$post(URL.allgrade).then((res) => {
        // console.log(res);
        this.gradedata = res.result.grade_list;
        this.gid = res.result.grade_list[0].gid;
        this.getgetsubject();
      });
    },
    handleGrade(res) {
      this.gradeOne = res.grade_name;
      this.gid = res.gid;
      VueEvent.$emit("grade", res.gid);
      this.getgetsubject();
    },
    handleSub(res) {
      this.subjectOne = res.subject_name;
      // console.log(res.sid);
      VueEvent.$emit("subject", res.sid);
    },
    //获取科目
    getgetsubject() {
      var subjectval = {
        gid: this.gid,
      };
      this.$post(URL.getsubject, subjectval).then((res) => {
        this.subjectdata = res.result.subject_list;
      });
    },
  },
};
</script>

<style lang='less' scoped>
.toptitle {
  background-color: #fff;
  padding: 20px 30px;
  margin-top: 20px;
  border-radius: 6px;
  .el-input {
    margin-left: 20px;
    width: 15% !important;
  }

  .el-dropdown {
    margin-left: 20px;
  }
  .el-date-editor--daterange.el-input,
  .el-date-editor--daterange.el-input__inner,
  .el-date-editor--timerange.el-input,
  .el-date-editor--timerange.el-input__inner {
    width: 200px !important;
  }
  .el-time-range-picker {
    width: 245px !important;
  }
}
</style>
